document.addEventListener("DOMContentLoaded", () => {
  
  // --- PART 1: INJECT THE HEADER BUTTON ---
  const initHeaderButton = () => {
    const headerContainer = document.querySelector('.header__column.header__column--right');
    
    // Fail gracefully if the container isn't found
    if (!headerContainer) return; 

    const reviewBtn = document.createElement('a');
    reviewBtn.href = '#free-case-review';
    reviewBtn.className = 'button btn-free-review';
    reviewBtn.textContent = 'FREE CASE REVIEW';

    headerContainer.appendChild(reviewBtn);
  };

  // --- PART 2: MODAL LOGIC & GLOBAL TRIGGERS ---
  const initModalLogic = () => {
    const modal = document.getElementById('caseReviewModal');
    const closeBtn = document.getElementById('closeModalBtn');

    if (!modal) return;

    // Open modal on ANY link with href="#free-case-review"
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#free-case-review"]');
      
      if (trigger) {
        event.preventDefault(); // Prevent the page from jumping
        modal.classList.add('is-active');
      }
    });

    // Close modal when clicking the 'X'
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        modal.classList.remove('is-active');
      });
    }

    // Close modal when clicking outside the white box
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.classList.remove('is-active');
      }
    });
  };

  // --- PART 3: CHECK FOR SHOPIFY SUCCESS REDIRECT ---
  const handleFormSuccess = () => {
    const modal = document.getElementById('caseReviewModal');
    if (!modal) return;

    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('contact_posted') === 'true') {
      // Open the modal immediately on page load
      modal.classList.add('is-active');
      
      // Swap the form for a success message
      const form = modal.querySelector('form');
      if (form) {
        // Fixed the missing 'style=' attribute in the h3 tag below
        form.innerHTML = `
          <div class="form-success-message" style="text-align: center; padding: 20px 0;">
            <h3 style="margin-bottom: 10px;">Message Sent Successfully!</h3>
            <p>Thank you for reaching out. Jack will review your case and get back to you shortly.</p>
          </div>
        `;
      }

      // Clean up the URL so the modal doesn't re-open on refresh
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, null, window.location.pathname);
      }
    }
  };

  // --- PART 4: ANNOUNCEMENT BAR INJECTION ---
  const initAnnouncementBar = () => {
    const headerElement = document.querySelector('header');
    
    // Fail gracefully if the header doesn't exist
    if (!headerElement) return;

    // 1. Create the main outer bar (Adding the 'section' class here)
    const announcementBar = document.createElement('div');
    announcementBar.className = 'custom-announcement-bar section';

    // 2. Create the inner container to hold the content
    const announcementContainer = document.createElement('div');
    announcementContainer.className = 'announcement-bar__content';

    // 3. Create Left Section (Language Switcher)
    const leftSection = document.createElement('div');
    leftSection.className = 'announcement-left';
    
    // Safely calculate paths 
    const currentPath = window.location.pathname.replace(/^\/es/, '');
    const engLink = currentPath === '' ? '/' : currentPath;
    const espLink = '/es' + currentPath;

    leftSection.innerHTML = `
      <a href="${engLink}"><i>ENG</i></a> | <a href="${espLink}"><i>ESP</i></a>
    `;

    // 4. Create Right Section (Social Links)
    const rightSection = document.createElement('div');
    rightSection.className = 'announcement-right';

    const socialWrapper = document.querySelector('.social-icons__wrapper');
    if (socialWrapper) {
      const clonedWrapper = socialWrapper.cloneNode(true);
      rightSection.appendChild(clonedWrapper);
    }

    // 5. Assemble the bar
    // Drop the left and right sides into the inner container
    announcementContainer.appendChild(leftSection);
    announcementContainer.appendChild(rightSection);

    // Drop the inner container into the main outer section
    announcementBar.appendChild(announcementContainer);

    // 6. Inject it directly before the <header> element
    headerElement.insertAdjacentElement('beforebegin', announcementBar);
  };

  // --- INITIALIZE ALL FUNCTIONS ---
  initHeaderButton();
  initModalLogic();
  handleFormSuccess();
  initAnnouncementBar();
});